import React from "react";
import { Field, FieldProps, FormikProps } from "formik";
import { TextField } from "@material-ui/core";

interface IProps {
  fieldName: string;
  label: string;
  formikProps: FormikProps<any>;
  disabled?: boolean;
}

export default class NumberField extends React.Component<IProps> {
  render() {
    return (
      <Field
        name={this.props.fieldName}
        render={({ field }: FieldProps) => (
          <TextField
            {...field}
            fullWidth
            type="number"
            label={this.props.label}
            disabled={Boolean(this.props.disabled)}
            error={
              this.props.formikProps.touched[this.props.fieldName] &&
              !!this.props.formikProps.errors[this.props.fieldName]
            }
            helperText={
              this.props.formikProps.touched[this.props.fieldName] &&
              this.props.formikProps.errors[this.props.fieldName]
            }
          />
        )}
      />
    );
  }
}
